"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleEmailSent = handleEmailSent;
exports.handleEmailSentWithBrandingBanner = handleEmailSentWithBrandingBanner;
exports.logEmailBrandingRemoval = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _loggers = require("customer-data-tracking/loggers");

var _hubspotTracking = _interopRequireDefault(require("crm_internal/utils/hubspotTracking"));

var _TrackingEvents = _interopRequireDefault(require("crm_internal/config/TrackingEvents"));

var _ObjectTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectTypes"));

var _EmailMediaAttachmentCountsRecord = _interopRequireDefault(require("customer-data-communicator/data/interactions/email/EmailMediaAttachmentCountsRecord"));

var logEmailSent = function logEmailSent() {
  var mediaAttachmentCounts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _EmailMediaAttachmentCountsRecord.default)();

  _loggers.CrmLogger.log('recordUsage', (0, _extends2.default)({
    action: 'sent email to contact',
    type: _ObjectTypes.default.CONTACT
  }, mediaAttachmentCounts.toJS()));

  _loggers.CrmLogger.log('recordUsage', {
    action: 'track email',
    type: _ObjectTypes.default.CONTACT
  });
};

var logEmailSentWithBanner = function logEmailSentWithBanner() {
  _loggers.CrmLogger.log('virality-sent-email-with-brand-banner', {
    action: 'sent email with banner',
    loop: 'crm-email-signature-branding'
  });
};

var logEmailBrandingRemoval = function logEmailBrandingRemoval() {
  _loggers.CrmLogger.log('virality-removed-brand-banner', {
    action: 'removed email banner',
    loop: 'crm-email-signature-branding'
  });
};

exports.logEmailBrandingRemoval = logEmailBrandingRemoval;

var logTemplateUsage = function logTemplateUsage(email) {
  if (email.templateId) {
    (0, _hubspotTracking.default)(_TrackingEvents.default.HUBSPOT.USED_TEMPLATE_DATE);
    (0, _hubspotTracking.default)(_TrackingEvents.default.SIDEKICK.USED_TEMPLATE_DATE);
  }
};

function handleEmailSent(_ref) {
  var email = _ref.email,
      mediaAttachmentCounts = _ref.mediaAttachmentCounts;
  logEmailSent(mediaAttachmentCounts);
  logTemplateUsage(email);
}

function handleEmailSentWithBrandingBanner() {
  logEmailSentWithBanner();
}